/** 
 * Represents nested columns for displaying custom search results
 */
export class NestedColumn {
    name: string;
    key?: string;
    columns: NestedColumn[];
}
